import moment from 'moment';

import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { finalize, map } from 'rxjs';

import { Notificacao } from './notificacoes.type';

import { RegisterIconsService } from 'src/app/services/register-icons.service';
import { NotificacoesServiceService } from './notificacoes-service.service';

import { ModalNotificacaoComponent } from './modal-notificacao/modal-notificacao.component';
@Component({
  selector: 'app-notificacoes',
  imports: [MatIconModule, MatTooltipModule, MatProgressSpinnerModule],
  templateUrl: './notificacoes.component.html',
  styleUrl: './notificacoes.component.scss'
})
export class NotificacoesComponent implements OnInit, OnChanges {

  private iconsService = inject(RegisterIconsService);
  private notificacoesService = inject(NotificacoesServiceService);
  private matDialog = inject(MatDialog);
  private router = inject(Router);

  @Input() notificacoes: Notificacao[] = [];
  @Input() notificacoesLidas: string[] = [];
  @Output() visualizar = new EventEmitter<string>();

  ngOnInit(): void {
    this.iconsService.registerIcons(['email-outline', 'update', 'comment-alert-outline', 'newspaper-variant-outline', 'menu-tarefas']);
    this.format();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['notificacoes']) {
      this.format();
    }
  }

  private format = (): void => {
    this.notificacoes = this.notificacoes.map(notificacao => ({
        ...notificacao,
        categoria: this.notificacoesService.tiposNotificacao[notificacao.tipo],
        tempoCriacao: this.verificaTempoCriacao(notificacao)
    }));
  }

  private verificaTempoCriacao = (notificacao: Notificacao): string => {
    const dataIni = moment(notificacao.dataIni);;
    const dataAtual = moment().locale('pt-br');

    const diferencaEmHoras = dataAtual.diff(moment(dataIni), 'hours');

    if (diferencaEmHoras >= 24) {
      const dias = dataAtual.diff(dataIni, 'days');
      return `Há ${dias} ${dias > 1 ? 'dias' : 'dia'}`;
    } else if (diferencaEmHoras < 24 && diferencaEmHoras >= 1) {
      return `Há ${diferencaEmHoras} ${diferencaEmHoras > 1 ? 'horas' : 'hora'}`;
    } else {
      const minutos = dataAtual.diff(dataIni, 'minutes');
      return `Há ${minutos} ${minutos > 1 ? 'minutos' : 'minuto'}`;
    }
  }

  protected handleOpenNotificacao = (event: Event, notificacao: Notificacao) => {
    event.stopPropagation();
    this.visualizar.emit(notificacao.id);
    this.matDialog.open(ModalNotificacaoComponent, {
      width: '400px',
      data: notificacao
    });
  }

  protected handleVerTodas = () => {
    this.router.navigateByUrl('/painel-notificacoes');
    this.notificacoesService.closeMenu$.next();
  }

  protected handleStopPropagation(event: Event): void {
    event.stopPropagation();
  }
}

